export class FCreneaux {
    
    idCreneau:number;
    dateCreneau: Date;
    libre: boolean;
    idSite:number;
    bloque: boolean;
   

    constructor(idCreneau:number, dateCreneau:Date, libre:boolean, idSite:number, bloque:boolean,  ){
      this.idCreneau = idCreneau;
      this.dateCreneau = dateCreneau;
      this.libre = libre;
      this.idSite = idSite;
      this.bloque = bloque
     

   }

   public static fromJson(json: Object): FCreneaux {
        
    return new FCreneaux(
        json['idCreneau'],
        json['dateCreneau'],
        json['libre'],
        json['idSite'],
        json['bloque']
        )
    }
  }